import { SelectOptionType } from '@octano/global-ui';
import { useState } from 'react';
import { DefaultValues } from 'react-hook-form';
import { FieldValues } from 'react-hook-form';
import DisplayError from '../info/DisplayError';
import RenderForm, { ButtonData } from './parts/RenderSections';

export interface DynamicFormBaseProps {
  defaultValues?: DefaultValues<any>;
  /**
   * optionalValues corresponde a valores por defecto
   * que dependen de una condicion para mostrarse.
   */
  optionalValues?: DefaultValues<any>;
  /**
   * Cuando dynamic form recibe un objeto con las opciones,
   * estas se mostrarán el el campo que coincida con el nombre
   * de la propiedad.
   */
  options?: Record<string, SelectOptionType[]>;
  /**
   * sectionComponents en el json se puede definir un componente a una seccion
   * cuando esto ocurre es necesario pasar un objeto con componentes a renderizar.
   */
  sectionComponents?: Record<string, JSX.Element>;
  /**
   * Buttons para el formulario
   */
  formButtons?: ButtonData[];
  structure?: any;
  isModalRender?: boolean;
  onSubmit: (data: FieldValues) => Promise<void>;
  onCancel?: () => void;
  readOnly?: boolean;
}

function DynamicFormBase(props: DynamicFormBaseProps) {
  const {
    structure,
    defaultValues,
    optionalValues,
    sectionComponents,
    options,
    onSubmit,
    onCancel,
    formButtons,
    isModalRender,
    readOnly,
  } = props;

  const [error, setError] = useState<string[]>();

  if (error) {
    return <DisplayError body={'Error de dependencias'} />;
  }

  if (!structure) {
    return <DisplayError body={'Estructura no cargada'} />;
  }

  if (structure.length === 0) {
    return (
      <div className="text-center p-4">
        <p>No hay campos personalizables configurados.</p>
      </div>
    );
  }

  return (
    <RenderForm
      sectionComponents={sectionComponents}
      structureBtns={formButtons}
      structure={structure}
      onErrors={setError}
      onSubmit={onSubmit}
      onCancel={onCancel}
      defaultValues={defaultValues}
      optionalValues={optionalValues}
      options={options}
      isModalRender={isModalRender}
      readOnly={readOnly}
    />
  );
}

export default DynamicFormBase;
